import { injectable } from "inversify";
import { from } from "rxjs";
import { CsvDocumentBuilder } from "./CsvDocumentBuilder.js";
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let CsvDocumentBuilderAdapter = class {
  createFile(data, keys, headers) {
    const columns = keys.reduce((previousValue, key, index) => {
      previousValue[key] = {
        key,
        header: headers?.[key] ?? key,
        colIndex: index + 1
      };
      return previousValue;
    }, {});
    const worksheetKey = "CSV File";
    const colDefs = Object.values(columns);
    const builder = new CsvDocumentBuilder();
    builder.setWorksheet(worksheetKey, {});
    builder.setColumns(worksheetKey, colDefs);
    builder.setData(worksheetKey, data);
    const document = builder.getDocument();
    return from(document.writeBuffer());
  }
};
CsvDocumentBuilderAdapter = __decorateClass([
  injectable()
], CsvDocumentBuilderAdapter);
export {
  CsvDocumentBuilderAdapter
};
//# sourceMappingURL=CsvDocumentBuilderAdapter.js.map
